import type {
	CommunicationStatusTab,
	CommunicationTabCounts,
	CommunicationVehicle,
} from "../types";

export function communicationStatusTabToApi(
	tab: CommunicationStatusTab
): boolean | undefined {
	if (tab === "connected") {
		return true;
	}

	if (tab === "disconnected") {
		return false;
	}

	return;
}

export function communicationExportSuffix(tab: CommunicationStatusTab): string {
	if (tab === "connected") {
		return "conectados";
	}

	if (tab === "disconnected") {
		return "desconectados";
	}

	return "todos";
}

export function getCommunicationRowKey(
	item: CommunicationVehicle,
	index: number
): string {
	const plate = item.plate?.trim() ?? "unknown";
	const lastPosition = item.lastPosition ?? "unknown";
	return `${plate}|${lastPosition}|${index}`;
}

const TAB_COUNT_KEY: Record<
	CommunicationStatusTab,
	keyof CommunicationTabCounts
> = {
	all: "all",
	connected: "connected",
	disconnected: "disconnected",
};

export function getTabBadgeValue(
	tab: CommunicationStatusTab,
	counts: CommunicationTabCounts,
	isLoading: boolean
): string | number {
	if (isLoading) {
		return "—";
	}

	return counts[TAB_COUNT_KEY[tab]];
}
